define('flight-components/ListingResults',[
  'App',
  'flight/lib/component',
  'flight-components/mixins/withListingsModal',
  'iframeresizer'
],
function (App, defineComponent, withListingsModal, iFrameResize) {

  var ListingResults = function ListingResults() {

    this.defaultAttrs({
      listingSelector: '.listing'
    });

    this.after('initialize', function () {
      if (App.page === 'groceryResults') {
    	  iFrameResize({checkOrigin: false, heightCalculationMethod: 'lowestElement'}, '#qples'); 
      }
    });

  };

  return defineComponent(ListingResults, withListingsModal);

});

